angular.module('ihestiaAg', [
  'ihestiaSsoBase.baseInfo',
  'ihestiaCommonDirectives.configHelper',
  'ihestiaRestServicesBase',
  'ihestiaCommonDirectives.platformHelper'
]);
